import { useEffect, useState } from 'react';
import { useI18n } from '../../i18n';
import { checklistLabel } from '../admin/checklist';
import type { ChecklistKey } from '../admin/api';
import { rpc } from './api';
import { langList, ownerLabel } from './readiness';

// K1 (B1, D1): while the school isn't Live, say what is missing and who acts,
// live from the checklist. The database still refuses a start (backstop).
type Readiness = {
  state: string;
  school_type: 'sandbox' | 'customer';
  is_demo: boolean;
  items: { key: ChecklistKey; level: 'required'; done: false; owner: 'zencera' | 'school_admin' | 'head'; missing: string[] | null }[];
  primary_head: string | null;
  school_admins: string[];
};

export function ReadinessBanner({ state }: { state: string }) {
  const { t } = useI18n();
  const [r, setR] = useState<Readiness | null>(null);
  useEffect(() => {
    if (state === 'live') return;
    rpc<Readiness>('school_readiness').then((x) => setR(x.error ? null : x.data));
  }, [state]);
  if (state === 'live') return null;

  const who = r
    ? r.school_type === 'sandbox'
      ? t['r4.ready.sandbox'](r.primary_head)
      : r.school_admins?.length || r.primary_head
        ? t['r4.ready.customer']([...(r.school_admins ?? []), ...(r.primary_head ? [r.primary_head] : [])].join(', '))
        : t['r4.ready.customerNobody']
    : null;

  return (
    <section className="notice notice-block readiness" role="status" aria-labelledby="ready-title">
      <p className="readiness-title" id="ready-title"><strong>{t['r4.ready.title']}</strong></p>
      {who && <p>{who}</p>}
      {r && r.items?.length > 0 && (
        <>
          <p className="field-label">{t['r4.ready.missing']}</p>
          <ul className="readiness-list">
            {r.items.map((i) => (
              <li key={i.key}>
                {checklistLabel(t, i.key, r.school_type === 'sandbox')}
                {i.missing && i.missing.length > 0 && <> ({t['r4.ready.missingLangs'](langList(t, i.missing))})</>}
                <span className="text-muted"> · {t['r4.owner'](ownerLabel(t, i.owner))}</span>
              </li>
            ))}
          </ul>
        </>
      )}
      <p className="form-hint">{t['r4.ready.startHint']}</p>
    </section>
  );
}
